import { getSierraSecrets } from './getSierraSecrets.ts';

function updateSierraSecrets({
    userToken,
    sellerToken,
    sfChatToken,
}: {
    userToken: string | null | undefined;
    sellerToken: string | null | undefined;
    sfChatToken: string | null | undefined;
}): void {
    const secrets = getSierraSecrets({ userToken, sellerToken, sfChatToken });

    if (secrets) {
        window.sierra?.updateSecrets?.(secrets);
    }
}

export { updateSierraSecrets };
